import React from 'react';

export default function Media() {
  return (
    <div>
      <h1 className="h4 mb-3">Media</h1>
      <p className="text-muted">Manage media assets.</p>
    </div>
  );
}
